module.exports = __webpack_public_path__ + "static/media/siemens.bd2377c9.svg";